import { Action } from 'redux';
import { MessagesState } from 'src/store';

export const actionTypes = {
  SHOW_TOAST: 'toast/SHOW',
};

export namespace actions {
  function msg(type: 'info' | 'success' | 'warning' | 'error', content: React.ReactNode) {
    return {
      type: actionTypes.SHOW_TOAST,
      payload: { type, content }
    };
  }

  export function success(content: React.ReactNode) {
    return msg('success', content);
  }

  export function error(content: React.ReactNode) {
    return msg('error', content);
  }
}
export namespace reducers {
  export const reducer = (
    state: MessagesState = { messages: [] },
    action: Action & { payload: { type: string, content: string } },
  ) => {
    switch (action.type) {
      case actionTypes.SHOW_TOAST: {
        const { type, content } = action.payload;
        return {
          messages: [...state.messages, { type, content }]
        };
      }
      default:
        return state;
    }
  };
}


// WEBPACK FOOTER //
// ./src/toast/redux.ts